import {
  CREATE_SETUP_INTENT,
  DELETE_PAYMENT_METHOD,
  FETCH_CUSTOMER_BY_TENANT_ID,
  FETCH_PAYMENT_METHODS_BY_CUSTOMER_ID,
} from './financialPartner.gql';
import { getApolloClient } from '../lib/getApolloClient';
import {
  Customer,
  DeletePaymentMethodResponse,
  PaymentMethod,
  SetupIntent,
} from '../generated/gql-types';

const fetchCustomerByTenantId = async (
  tenantId: string,
): Promise<Customer | null> => {
  try {
    const { data } = await getApolloClient().query({
      query: FETCH_CUSTOMER_BY_TENANT_ID,
      variables: { tenantId },
    });
    if (data.getCustomerByTenantId) {
      return data.getCustomerByTenantId;
    }
    return null;
  } catch (error) {
    console.error('Error fetching customer by email:', error);
    return null;
  }
};

const fetchPaymentMethodsByCustomerId = async (
  customerId: string,
): Promise<PaymentMethod[] | null> => {
  try {
    const { data } = await getApolloClient().query({
      query: FETCH_PAYMENT_METHODS_BY_CUSTOMER_ID,
      variables: { customerId },
    });
    if (data.getPaymentMethodByCustomerId) {
      return data.getPaymentMethodByCustomerId;
    }
    return null;
  } catch (error) {
    console.error('Error fetching payment methods by customer id:', error);
    return null;
  }
};

const createSetupIntent = async (customerId: string): Promise<SetupIntent> => {
  try {
    const { data } = await getApolloClient().mutate({
      mutation: CREATE_SETUP_INTENT,
      variables: { customerId },
    });
    return data.createSetupIntent;
  } catch (error) {
    console.error('Error creating setup intent:', error);
    throw error;
  }
};

const deletePaymentMethod = async (
  paymentMethodId: string,
  tenantId: string,
): Promise<DeletePaymentMethodResponse> => {
  try {
    const { data } = await getApolloClient().mutate({
      mutation: DELETE_PAYMENT_METHOD,
      variables: { paymentMethodId, tenantId },
    });
    return data.deletePaymentMethod;
  } catch (error) {
    console.error('Error deleting payment method:', error);
    throw error;
  }
};

export const financialPartnerActions = {
  fetchCustomerByTenantId,
  fetchPaymentMethodsByCustomerId,
  createSetupIntent,
  deletePaymentMethod,
};
